<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.feriado"
        ref="DataTable"
        sort-by="ano"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'cadastro-feriado-edit', params: { id: item.id } })"
                color="primary"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>

// Mixins.
import { repository, error } from '@/mixins'


export default {
    created() {

        this.repositories = {
            feriado: this.getConectaSusRepository('cadastro.feriado.feriado')
        }
    },
    computed: {

        fields() {
            return [
                {
                    name: 'cadastro_feriado.dia',
                    key: 'dia',
                    label: 'Dia',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'cadastro_feriado.mes',
                    key: 'mes',
                    label: 'Mês',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'cadastro_feriado.ano',
                    key: 'ano',
                    label: 'Ano',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'cadastro_feriado_tipo.descricao',
                    key: 'tipoDescricao',
                    label: 'Tipo',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'observacao',
                    key: 'observacao',
                    label: 'Descrição',
                    searchable: true,
                    sortable: true
                },
                {
                    name: 'actions',
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min'
                },
            ]
        }
    },
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.feriado.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir o feriado?', destroy, this.handleError)
        },
    },
    mixins: [ repository, error ],
}
</script>